import { useGenericRequestHandler } from '../../../handlers'

/**
 * @typedef {'required' | 'dismissed' | 'completed' | 'skip_for_now'} GoalStatus
 */

/**
 * @typedef {Object} UseUpsertGoalsMutationVariables
 * @property {string} goalName
 * @property {GoalStatus} goalStatus
 */

/**
 * @return {{mutate: ({variables: UseUpsertGoalsMutationVariables}) => Promise<void>}}
 */
export function useUpsertGoalsMutation() {
  return useGenericRequestHandler({
    route: `v1/i/upsertGoals`,
    method: 'POST'
  })
}
